import { useState, useEffect } from 'react';
import { FetchUserCountryEventData } from '../Utils/FetchUserCountryEventData';

export const useCountryEvents = (userid, countryid) => {
  const [countryEventsData, setCountryEventsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadEvents = async () => {
      try {
        setLoading(true);
        const data = await FetchUserCountryEventData(userid, countryid);
        setCountryEventsData(data);
        setError(null);
      } catch (err) {
        console.error("Error loading last month events:", err);
        setError(err);
        setCountryEventsData(null);
      } finally {
        setLoading(false);
      }
    };
    loadEvents();
  }, [userid, countryid]);

  return { 
    countryEventsData, 
    loading, 
    error,
    countryEvents: countryEventsData?.events || []
  }
};
